import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle } from 'lucide-react';
const testimonials = [{
  initial: 'N',
  color: 'bg-pink-100 text-pink-700',
  name: 'Natalia M.',
  location: 'Mamá de Valentín, 5to grado, Buenos Aires',
  text: 'No podía creer que mi hijo me pidiera hacer la misión del día. Nunca lo vi tan motivado con algo educativo en su vida.'
}, {
  initial: 'D',
  color: 'bg-blue-100 text-blue-700',
  name: 'Diego R.',
  location: 'Papá de Sofía, 5to grado, Córdoba',
  text: 'Lo compré el domingo a la noche y el lunes ya estábamos empezando. Súper fácil de implementar y mi hijo lo tomó como un juego desde el primer momento.'
}, {
  initial: 'C',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Cecilia T.',
  location: 'Mamá de Martina, 5to grado, Rosario',
  text: 'La maestra me dijo que Martina volvió con muy buen nivel de lectura y matemática. No me lo esperaba después de 15 días de vacaciones.'
}, {
  initial: 'F',
  color: 'bg-amber-100 text-amber-700',
  name: 'Florencia B.',
  location: 'Mamá de dos nenes de primaria, Mendoza',
  text: 'El Checklist Anti-Pantalla me salvó las vacaciones. Por primera vez mis hijos dejaron el celular sin que yo tuviera que gritar.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-177">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-178">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-179">
          <MessageCircle className="w-10 h-10 text-[#d4a017] mb-4" data-id="element-180" />
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2f3a2c]" data-id="element-181">
            Lo que otros padres están diciendo
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-182">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full" data-id="element-183">
              <div className="flex text-[#d4a017] mb-4" data-id="element-184">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-185" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic flex-grow" data-id="element-186">
                "{t.text}"
              </p>

              <div className="flex items-center border-t border-slate-100 pt-4 mt-auto" data-id="element-187">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3 flex-shrink-0`} data-id="element-188">
                  {t.initial}
                </div>
                <div data-id="element-189">
                  <div className="font-bold text-[#2f3a2c] text-sm" data-id="element-190">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-191">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}